import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  InputLabel,
  makeStyles,
  TextField,
  IconButton,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { green } from '@material-ui/core/colors';
import { STATUS_API } from 'src/app/constant/config';
import { Formik } from 'formik';
import { createAgency, getListAgencyBusiness, resetChange } from 'src/features/agencySlice';
import { getListProvinces } from 'src/features/provinceSlice';
import * as Yup from 'yup';
import CustomDialog from 'src/app/components/CustomDialog';
import AgencyAccountInfoDialog from './AgencyAccountInfoDialog';

const initStateFromValue = {
  username: '',
  agency_name: '',
  email: '',
  password: '123456',
  confirm_password: '123456',
  phone: '',
  full_name: '',
  address: '',
  province_id: '',
  business_id: '',
  business_name: '',
  tax_code: ''
};

function CreateAgency({ open, onClose, onCreated }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const statusCreate = useSelector(state => state.agencySlice.statusCreate);
  const listProvinces = useSelector(state => state.provinceSlice.listProvinces);
  const [initValue, setInitValue] = useState(initStateFromValue);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showAccountInfo, setShowAccountInfo] = useState(false);
  const [accountInfo, setAccountInfo] = useState(null);

  const handleSubmit = (values) => {
    dispatch(resetChange());
    const { confirm_password, ...data } = values;
    const newAgency = {
      ...data,
      username: data.username ? data.username : null,
      address: data.address ? data.address : ' ',
      email: data.email ? data.email : 'user@example.com',
      business_id: 1,
      province_id: data.province_id,
      full_name: ' ',
      business_name: data.business_name ? data.business_name : null,
      tax_code: data.tax_code ? data.tax_code : null
    };

    setInitValue(newAgency);
    dispatch(createAgency(newAgency)).then(action => {
      if (createAgency.fulfilled.match(action)) {
        const info = {
          username: newAgency.username || newAgency.phone,
          password: newAgency.password
        };
        setAccountInfo(info);
        onCreated && onCreated(info);
      }
    });
  };

  const handleClose = () => {
    onClose();
    setInitValue(initStateFromValue);
    dispatch(resetChange());
  };

  useEffect(() => {
    dispatch(getListAgencyBusiness());
  }, []);

  useEffect(() => {
    if (statusCreate === STATUS_API.SUCCESS) {
      onClose();
      setInitValue(initStateFromValue);
      dispatch(resetChange());
      setShowAccountInfo(true);
    }
  }, [statusCreate]);

  return (
    <>
    <AgencyAccountInfoDialog
      open={showAccountInfo}
      onClose={() => setShowAccountInfo(false)}
      accountInfo={accountInfo}
    />
    <CustomDialog title={'Thêm mới đại lý'} open={open} onClose={handleClose}>
      <div>
        <Formik
          initialValues={initValue}
          validationSchema={Yup.object().shape({
            username: Yup.string()
              .max(100)
              .matches(/^\S+$/, 'Tên đăng nhập không được chứa khoảng trắng')
              .matches(
                /^[a-zA-Z0-9_]+$/,
                'Tên đăng nhập không được chứa ký tự đặc biệt'
              ),
            agency_name: Yup.string()
              .max(150)
              .required('Tên đại lý không được để trống'),
            email: Yup.string().email('Email chưa đúng định dạng'),
            phone: Yup.string()
              .matches(
                /^(84|0[3|5|7|8|9])+([0-9]{8})$/,
                'Số điện thoại chưa đúng định dạng'
              )
              .required('Số điện thoại không được để trống'),
            address: Yup.string()
              .max(150),
            business_name: Yup.string()
              .max(150),
            tax_code: Yup.string()
              .max(100),
            province_id: Yup.string()
              .max(100)
              .required('Tỉnh thành không được để trống'),
            business_id: Yup.string()
              .max(100),
            password: Yup.string()
              .max(100)
              .required('Mật khẩu không được để trống'),
            confirm_password: Yup.string()
              .oneOf([Yup.ref('password'), null], 'Mật khẩu chưa khớp')
              .required('Xác nhận lại mật khẩu')
          })}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Tên đại lý <span style={{ color: 'red' }}>*</span>{' '}
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.agency_name && errors.agency_name)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.agency_name && errors.agency_name}
                    margin="normal"
                    name="agency_name"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.agency_name}
                    variant="outlined"
                    placeholder="Nhập tên đại lý"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Số điện thoại{' '}
                    <span style={{ color: 'red' }}>*</span>{' '}
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.phone && errors.phone)}
                    fullWidth
                    className="input-no-fieldset"
                    helperText={touched.phone && errors.phone}
                    margin="normal"
                    size="small"
                    name="phone"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.phone}
                    variant="outlined"
                    placeholder="Nhập số điện thoại"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Tên đăng nhập{' '}
                    <span style={{ color: 'red' }}></span>{' '}
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.username && errors.username)}
                    fullWidth
                    className="input-no-fieldset"
                    helperText={touched.username && errors.username}
                    margin="normal"
                    size="small"
                    name="username"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.username}
                    variant="outlined"
                    placeholder="Nhập tên đăng nhập"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>Tên doanh nghiệp </InputLabel>
                  <TextField
                    error={Boolean(
                      touched.business_name && errors.business_name
                    )}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={
                      touched.business_name && errors.business_name
                    }
                    placeholder='Nhập tên doanh nghiệp'
                    margin="normal"
                    name="business_name"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.business_name}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      )
                    }}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>Mã số thuế </InputLabel>
                  <TextField
                    error={Boolean(touched.tax_code && errors.tax_code)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.tax_code && errors.tax_code}
                    placeholder='Nhập mã số thuế'
                    margin="normal"
                    name="tax_code"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.tax_code}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      )
                    }}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Địa chỉ <span style={{ color: 'red' }}></span>{' '}
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.address && errors.address)}
                    className="input-no-fieldset"
                    fullWidth
                    helperText={touched.address && errors.address}
                    margin="normal"
                    name="address"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.address}
                    variant="outlined"
                    placeholder="Nhập địa chỉ"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel style={{ marginBottom: "21px" }}>
                    Tỉnh thành <span className="text-danger">*</span>
                  </InputLabel>

                  <Autocomplete
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    size="small"
                    options={listProvinces || []}
                    getOptionLabel={option => option.name}
                    value={(listProvinces || []).find(
                      option => option.id === values.province_id
                    )}
                    onChange={(e, value) => setFieldValue("province_id", value.id)}
                    disableClearable
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Chọn tỉnh thành"
                        name="province_id"
                        error={Boolean(touched.province_id && errors.province_id)}
                        helperText={touched.province_id && errors.province_id}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '35px',
                          }
                        }}
                      />
                    )}
                    className={classes.customOutline}
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Email <span style={{ color: 'red' }}></span>{' '}
                  </InputLabel>
                  <TextField
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    margin="normal"
                    className="input-no-fieldset"
                    name="email"
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    variant="outlined"
                    placeholder="Nhập email"
                  />
                </Grid>

                {/* <Grid item md={6} xs={12}>
                  <InputLabel>
                    Loại đại lý <span className="text-danger">*</span>
                  </InputLabel>
                  <TextField
                    className="input-no-fieldset"
                    size="small"
                    fullWidth
                    select
                    error={Boolean(touched.business_id && errors.business_id)}
                    helperText={touched.business_id && errors.business_id}
                    margin="normal"
                    name="business_id"
                    onBlur={handleBlur}
                    onChange={e =>
                      handleChoose(e, 'business_type', setFieldValue)
                    }
                    SelectProps={{
                      native: true
                    }}
                    value={values.business_id}
                    variant="outlined"
                  >
                    <option>Chọn loại đại lý</option>
                    {listAgencyBusiness &&
                      listAgencyBusiness.map(option => (
                        <option key={option.id} value={option.id}>
                          {option.title}
                        </option>
                      ))}
                  </TextField>
                </Grid> */}

                <Grid item md={3} xs={12}>
                  <InputLabel>
                    Tạo mật khẩu <span style={{ color: 'red' }}>*</span>{' '}
                  </InputLabel>

                  <TextField
                    error={Boolean(touched.password && errors.password)}
                    fullWidth
                    helperText={touched.password && errors.password}
                    margin="normal"
                    className="input-no-fieldset"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    size="small"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(prev => !prev)}
                          >
                            {showPassword ? (
                              <VisibilityOff style={{ color: '#D9042F' }} />
                            ) : (
                              <Visibility style={{ color: '#D9042F' }} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    variant="outlined"
                    placeholder="Nhập mật khẩu"
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <InputLabel>
                    Nhập lại mật khẩu <span style={{ color: 'red' }}>*</span>{' '}
                  </InputLabel>
                  <TextField
                    error={Boolean(
                      touched.confirm_password && errors.confirm_password
                    )}
                    fullWidth
                    helperText={
                      touched.confirm_password && errors.confirm_password
                    }
                    margin="normal"
                    className="input-no-fieldset"
                    name="confirm_password"
                    size="small"
                    type={showConfirmPassword ? 'text' : 'password'}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.confirm_password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setShowConfirmPassword(prev => !prev)
                            }
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff style={{ color: '#D9042F' }} />
                            ) : (
                              <Visibility style={{ color: '#D9042F' }} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    variant="outlined"
                    placeholder="Nhập lại mật khẩu"
                  />
                </Grid>
              </Grid>
              <Box my={3}>
                <div className={classes.groupButtonSubmit}>
                  <div className={classes.wrapper}>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 90 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      onClick={() => onClose()}
                      className="btn-main btn-plain mx-3"
                      color="primary"
                      size="large"
                      variant="contained"
                    >
                      Thoát
                    </Button>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 120 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      className="btn-main mx-3"
                      color="primary"
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Thêm mới
                    </Button>
                    {statusCreate === STATUS_API.PENDING && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </div>
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog>
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',

    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    },
  }
}));

export default React.memo(CreateAgency);
